import { MatFormFieldDefaultOptions } from "@angular/material/form-field";

export const MAT_FORM_FIELD_CUSTOM_OPTIONS: MatFormFieldDefaultOptions = {
    appearance: 'outline'
}
